import React from "react";
import style from './measurementLoader.module.scss';
import measurements_loader from "../../../../static/images/measurements_loader.gif";

export const MeasurementLoader = ({ pendingRetires, maxPendingRetries }) => {
  return (
    <div className={`${style.loader_position} ${style.loader_text} text-center`}>
      <h3 className={`pt-5 pb-2`}>Measuring the wound</h3>
      <p>{pendingRetires >= maxPendingRetries ? "It's taking longer than usual, please check back after 5 mins." : "This won't take long"}</p>
      <img src={measurements_loader} alt="loading" className={style.loader_gif} />
    </div>
  );
};
